



import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class ButtonSuccessful extends Vue {
  @Prop({required: false, type: Boolean, default: false}) isLoading?: boolean
  @Prop({required: true, type: String, default: ''}) text!: string
  @Prop({required: false, type: String, default: 'button'}) type!: string
  @Prop({required: false, type: [String, Number], default: '339px'}) width !: string | number
  @Prop({required: false, type: [String, Number], default: '44px'}) height !: string | number
  @Prop({required: false, type: Boolean, default: false}) disabled ?: boolean

  private get textButton(): string {
    if (!this.text) return this.$t('common.button.buttonName').toString()
    return this.text
  }

  public onClickToButton(): void {
    this.$emit('clickButton')
  }
}
